export default __webpack_public_path__ + "static/media/cards1.823b1475.png";